import React from 'react';
import { GenericModal } from 'src/components/Modals/GenericModal';
import Flex from 'src/components/BeaconV2Components/Flex/Flex';
import { Divider, FormGroup } from '@mui/material';
import { Text } from 'src/components/BeaconV2Components/Generic/Text';
import colors from 'src/utils/colors';
import { SlButton } from 'src/components/BeaconV2Components/Header/SLDropdownMenu/SlButton';
import CheckboxItem from 'src/components/BeaconV2Components/ExperimentalLayout/Topics/TopicBuilder/components/CheckboxItem';
import { useContentUtilizationStore } from 'src/components/BeaconV2Components/ExperimentalLayout/ContentV3/components/stores/ContentUtilizationStore';
import { getItemHighlightsDisplayConfig } from 'src/utils/app';

const ContentUtilizationModal = () => {
  const { isOpen, tempFilters, closeModal, setTempFilter, resetFilters, applyFilters } = useContentUtilizationStore();
  const { showItemHighlights } = getItemHighlightsDisplayConfig();

  const handleApply = () => {
    applyFilters();
  };

  const handleClear = () => {
    resetFilters();
  };

  return (
    <GenericModal
      open={isOpen}
      onClose={closeModal}
      sx={{
        '& .MuiPaper-root': {
          padding: '18px 24px 16px 24px',
          width: '450px'
        },
        '& .genericModal__body': {
          height: '420px'
        },
        '& .genericModal__header': {
          position: 'relative',
          paddingBottom: '18px',
          justifyContent: 'center',
          '&::after': {
            content: '""',
            position: 'absolute',
            bottom: 0,
            left: '-24px',
            width: 'calc(100% + 48px)',
            height: '1px',
            backgroundColor: colors.graysSecondary
          },
          '& h4': {
            width: '100%',
            textAlign: 'center'
          },
          svg: {
            position: 'absolute',
            right: 0,
            top: '50%',
            transform: 'translateY(-100%)'
          }
        }
      }}
    >
      <GenericModal.Header title="Utilization Filter" onClose={closeModal} />
      <GenericModal.Body>
        <Flex flexDirection="column" gap={24} sx={{ padding: '24px 0 40px' }}>
          <Text variant="body2">Use the filters below to view products with low content utilization scores.</Text>

          <FormGroup
            sx={{
              display: 'flex',
              flexDirection: 'column',
              gap: '16px'
            }}
          >
            <CheckboxItem
              checked={tempFilters.titleUtilization}
              onClick={(e) => setTempFilter('titleUtilization', e.target.checked)}
              label="Title Utilization below 70%"
              value="titleUtilization"
              textSx={{ maxWidth: 'unset' }}
            />
            <CheckboxItem
              checked={tempFilters.titleOverLimit}
              onClick={(e) => setTempFilter('titleOverLimit', e.target.checked)}
              label="Titles over 75 characters"
              value="titleOverLimit"
              textSx={{ maxWidth: 'unset' }}
            />
            {showItemHighlights && (
              <CheckboxItem
                checked={tempFilters.itemHighlightsUtilization}
                onClick={(e) => setTempFilter('itemHighlightsUtilization', e.target.checked)}
                label="Item Highlights Utilization below 70%"
                value="itemHighlightsUtilization"
                textSx={{ maxWidth: 'unset' }}
              />
            )}
            <CheckboxItem
              checked={tempFilters.bulletUtilization}
              onClick={(e) => setTempFilter('bulletUtilization', e.target.checked)}
              label="Bullet Utilization below 70%"
              value="bulletUtilization"
              textSx={{ maxWidth: 'unset' }}
            />
            <CheckboxItem
              checked={tempFilters.descriptionUtilization}
              onClick={(e) => setTempFilter('descriptionUtilization', e.target.checked)}
              label="Description Utilization below 70%"
              value="descriptionUtilization"
              textSx={{ maxWidth: 'unset' }}
            />
            <CheckboxItem
              checked={tempFilters.imageUtilization}
              onClick={(e) => setTempFilter('imageUtilization', e.target.checked)}
              label="Image Utilization below 70%"
              value="imageUtilization"
              textSx={{ maxWidth: 'unset' }}
            />
            <CheckboxItem
              checked={tempFilters.videoUtilization}
              onClick={(e) => setTempFilter('videoUtilization', e.target.checked)}
              label="Video Utilization below 100%"
              value="videoUtilization"
              textSx={{ maxWidth: 'unset' }}
            />
            <CheckboxItem
              checked={tempFilters.enhancedUtilization}
              onClick={(e) => setTempFilter('enhancedUtilization', e.target.checked)}
              label="Enhanced Utilization below 100%"
              value="enhancedUtilization"
              textSx={{ maxWidth: 'unset' }}
            />
          </FormGroup>
        </Flex>
      </GenericModal.Body>
      <Divider
        sx={{
          margin: '0 -24px',
          width: 'calc(100% + 48px)'
        }}
      />
      <Flex
        gap={16}
        justifyContent="space-between"
        sx={{
          paddingTop: '16px'
        }}
      >
        <SlButton onClick={handleClear}>Clear</SlButton>
        <SlButton onClick={handleApply} variant="contained">
          Apply
        </SlButton>
      </Flex>
    </GenericModal>
  );
};

export default ContentUtilizationModal;
